(() => {
const parent = document.querySelector('.product-recommendations');

if (parent) {
  const observer = new MutationObserver((mutations, obs) => {
    if(document.querySelector('.container .product-recommendations__item')){
        bindProductCardVideoHover();
    }else{
        console.log('Not found')
    }
  });

  observer.observe(parent, { childList: true, subtree: true });
}else{
    console.log('No element found')
}
})();
